import { Button, Drawer } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { MdmTable } from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { SelectFromModalButton } from "src/components/SelectFromModalButton";
import { ZSidLabel } from "src/types";

import { valueCatalogsLoader } from "../apiValueCatalog";
import { ValueCatalogCardsFilter } from "../ValueCatalogFilter";
import { ZValueCatalog } from "../ZValueCatalog";

export type PropsSelectValueCatalog = {
  value?: ZSidLabel | null;
  onChange?(newValue?: ZSidLabel | null): void;
  disabled?: boolean;
};

export const SelectValueCatalog: React.FC<PropsSelectValueCatalog> = observer(
  (props) => {
    const { value, onChange, disabled } = props;
    const [store, setStore] = React.useState<
      RtStore<ZValueCatalog, ValueCatalogCardsFilter> | undefined
    >();
    const onOpen = () => {
      setStore(
        new RtStore({
          rowKey: "id",
          loader: valueCatalogsLoader(),
          selectionType: "radio",
        }),
      );
    };
    const onApply = () => {
      if (store) {
        const row = store.selectedRows[0];
        if (row) {
          const newValue: ZSidLabel = {
            id: row.id,
            label: row.name,
          };
          onChange?.(newValue);
          setStore(undefined);
        }
      }
    };
    return (
      <SelectFromModalButton
        onOpen={onOpen}
        disabled={disabled}
        options={value ? [value] : []}
        onChange={(list) => onChange?.(list?.[0])}
      >
        <Drawer
          title="Выбор каталога"
          open={!!store}
          onClose={() => setStore(undefined)}
          width="80vw"
          extra={
            <Button
              type="primary"
              disabled={!store?.selectedKeys.length}
              onClick={onApply}
            >
              Выбрать
            </Button>
          }
        >
          {store && <MdmTable store={store} columns={columns} />}
        </Drawer>
      </SelectFromModalButton>
    );
  },
);

const columns: RtColumn<ZValueCatalog>[] = [
  {
    key: "displayId",
    title: "Display Id",
    width: "100px",
    render: (row) => row.displayId,
  },
  {
    key: "name",
    title: "Название",
    render: (row) => row.name,
  },
];
